import { render } from "./DoughnutHistoricChart.vue?vue&type=template&id=40fb964d&scoped=true"
import script from "./DoughnutHistoricChart.vue?vue&type=script&lang=js"
export * from "./DoughnutHistoricChart.vue?vue&type=script&lang=js"

import "./DoughnutHistoricChart.vue?vue&type=style&index=0&id=40fb964d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fb964d"]])

export default __exports__